"use client";

import { Scale } from "@/animations/scale";
import Image from "@/components/Image";
import { cn } from "@/utils";
import { useResize } from "@/utils/useResize";
import { cva } from "class-variance-authority";
import { HeaderFinder } from "./header-finder";
import { WrapperFinder } from "./wrapper-finder";

const variants = cva("w-full", {
  variants: {
    twSize: {
      xs: "max-w-[80%] ml-[14px] mt-[41px]",
      sm: "max-w-[80%] ml-[14px] mt-[41px]",
      md: "max-w-[555px] ml-[14px] mt-[122px]",
      lg: "max-w-[557px] ml-[32px] mt-[135px]",
      xl: "max-w-[495px] ml-[150px] mt-[168px]",
      "2xl": "max-w-[526px] ml-[159px] mt-[179px]",
      "3xl": "max-w-[557px] ml-[169px] mt-[190px]",
    },
  },
  defaultVariants: {
    twSize: "2xl",
  },
});

export function FinderHoldBerachain() {
  const { twSize, width } = useResize();
  return (
    <Scale>
      <WrapperFinder className={cn(variants({ twSize: twSize }))}>
        <HeaderFinder>
          <p className="text-[#23262F] text-center text-[13px] font-medium leading-4 truncate">
            Holdstation On Berachain
          </p>
        </HeaderFinder>

        <div
          className={"flex flex-col rounded-b-2xl overflow-hidden"}
          style={{
            background:
              "linear-gradient(180deg, #E65D0E 0%, #F99861 100%), #FFF",
          }}
        >
          <div
            style={{
              backgroundImage:
                width < 768
                  ? `url(${require("@/assets/bg/bg_bera_mobile.png")})`
                  : `url(${require("@/assets/bg/bg_bera_desktop.png")})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundAttachment: "local",
              backgroundPosition: "bottom center",
              paddingBottom: width < 768 ? 196 : 0,
            }}
          >
            {/* content */}
            <div style={{}}>
              <div className="flex flex-col gap-1 relative">
                <div className="flex flex-col gap-3 p-5 md:pt-[140px]">
                  <p
                    className="text-[26px] font-medium leading-8 text-white "
                    style={{
                      textShadow: "0px 4px 8px rgba(0, 0, 0, 0.12)",
                    }}
                  >
                    DeFi products with
                    <br />
                    AI integration for ze Beras
                  </p>
                  <ul className="flex flex-col gap-1 list-none">
                    <li className="flex flex-row gap-2 items-center justify-start">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={14}
                        height={14}
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <title>Default</title>
                        <g clipPath="url(#clip0_613_13821)">
                          <path
                            d="M7.00033 1.16797C10.2221 1.16797 12.8337 3.77955 12.8337 7.0013C12.8337 10.2231 10.2221 12.8346 7.00033 12.8346C3.77858 12.8346 1.16699 10.2231 1.16699 7.0013C1.16699 3.77955 3.77858 1.16797 7.00033 1.16797ZM9.06241 4.89022L6.17491 7.77772L4.93824 6.54047C4.88408 6.48627 4.81978 6.44327 4.749 6.41393C4.67822 6.38458 4.60236 6.36946 4.52574 6.36943C4.371 6.36938 4.22257 6.4308 4.11312 6.54018C4.00366 6.64956 3.94214 6.79794 3.94208 6.95268C3.94203 7.10742 4.00345 7.25584 4.11283 7.3653L5.72166 8.97413C5.78125 9.03375 5.852 9.08104 5.92987 9.11331C6.00774 9.14557 6.0912 9.16218 6.17549 9.16218C6.25978 9.16218 6.34325 9.14557 6.42112 9.11331C6.49899 9.08104 6.56974 9.03375 6.62933 8.97413L9.88783 5.71563C9.99728 5.60618 10.0588 5.45772 10.0588 5.30293C10.0588 5.14813 9.99728 4.99968 9.88783 4.89022C9.77837 4.78076 9.62991 4.71927 9.47512 4.71927C9.32032 4.71927 9.17187 4.78076 9.06241 4.89022Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_613_13821">
                            <rect width={14} height={14} fill="white" />
                          </clipPath>
                        </defs>
                      </svg>

                      <span className="text-white text-base">
                        AI Agent launchpad for Beras
                      </span>
                    </li>
                    <li className="flex flex-row gap-2 items-center justify-start">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={14}
                        height={14}
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <title>Default</title>
                        <g clipPath="url(#clip0_613_13821)">
                          <path
                            d="M7.00033 1.16797C10.2221 1.16797 12.8337 3.77955 12.8337 7.0013C12.8337 10.2231 10.2221 12.8346 7.00033 12.8346C3.77858 12.8346 1.16699 10.2231 1.16699 7.0013C1.16699 3.77955 3.77858 1.16797 7.00033 1.16797ZM9.06241 4.89022L6.17491 7.77772L4.93824 6.54047C4.88408 6.48627 4.81978 6.44327 4.749 6.41393C4.67822 6.38458 4.60236 6.36946 4.52574 6.36943C4.371 6.36938 4.22257 6.4308 4.11312 6.54018C4.00366 6.64956 3.94214 6.79794 3.94208 6.95268C3.94203 7.10742 4.00345 7.25584 4.11283 7.3653L5.72166 8.97413C5.78125 9.03375 5.852 9.08104 5.92987 9.11331C6.00774 9.14557 6.0912 9.16218 6.17549 9.16218C6.25978 9.16218 6.34325 9.14557 6.42112 9.11331C6.49899 9.08104 6.56974 9.03375 6.62933 8.97413L9.88783 5.71563C9.99728 5.60618 10.0588 5.45772 10.0588 5.30293C10.0588 5.14813 9.99728 4.99968 9.88783 4.89022C9.77837 4.78076 9.62991 4.71927 9.47512 4.71927C9.32032 4.71927 9.17187 4.78076 9.06241 4.89022Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_613_13821">
                            <rect width={14} height={14} fill="white" />
                          </clipPath>
                        </defs>
                      </svg>

                      <span className="text-white text-base">
                        Build by ze Beras for ze Beras
                      </span>
                    </li>
                    <li className="flex flex-row gap-2 items-center justify-start">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={14}
                        height={14}
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <title>Default</title>
                        <g clipPath="url(#clip0_613_13821)">
                          <path
                            d="M7.00033 1.16797C10.2221 1.16797 12.8337 3.77955 12.8337 7.0013C12.8337 10.2231 10.2221 12.8346 7.00033 12.8346C3.77858 12.8346 1.16699 10.2231 1.16699 7.0013C1.16699 3.77955 3.77858 1.16797 7.00033 1.16797ZM9.06241 4.89022L6.17491 7.77772L4.93824 6.54047C4.88408 6.48627 4.81978 6.44327 4.749 6.41393C4.67822 6.38458 4.60236 6.36946 4.52574 6.36943C4.371 6.36938 4.22257 6.4308 4.11312 6.54018C4.00366 6.64956 3.94214 6.79794 3.94208 6.95268C3.94203 7.10742 4.00345 7.25584 4.11283 7.3653L5.72166 8.97413C5.78125 9.03375 5.852 9.08104 5.92987 9.11331C6.00774 9.14557 6.0912 9.16218 6.17549 9.16218C6.25978 9.16218 6.34325 9.14557 6.42112 9.11331C6.49899 9.08104 6.56974 9.03375 6.62933 8.97413L9.88783 5.71563C9.99728 5.60618 10.0588 5.45772 10.0588 5.30293C10.0588 5.14813 9.99728 4.99968 9.88783 4.89022C9.77837 4.78076 9.62991 4.71927 9.47512 4.71927C9.32032 4.71927 9.17187 4.78076 9.06241 4.89022Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_613_13821">
                            <rect width={14} height={14} fill="white" />
                          </clipPath>
                        </defs>
                      </svg>

                      <span className="text-white text-base">
                        Liquidity-centric DeFi ecosystem
                      </span>
                    </li>
                    <li className="flex flex-row gap-2 items-center justify-start">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={14}
                        height={14}
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <title>Default</title>
                        <g clipPath="url(#clip0_613_13821)">
                          <path
                            d="M7.00033 1.16797C10.2221 1.16797 12.8337 3.77955 12.8337 7.0013C12.8337 10.2231 10.2221 12.8346 7.00033 12.8346C3.77858 12.8346 1.16699 10.2231 1.16699 7.0013C1.16699 3.77955 3.77858 1.16797 7.00033 1.16797ZM9.06241 4.89022L6.17491 7.77772L4.93824 6.54047C4.88408 6.48627 4.81978 6.44327 4.749 6.41393C4.67822 6.38458 4.60236 6.36946 4.52574 6.36943C4.371 6.36938 4.22257 6.4308 4.11312 6.54018C4.00366 6.64956 3.94214 6.79794 3.94208 6.95268C3.94203 7.10742 4.00345 7.25584 4.11283 7.3653L5.72166 8.97413C5.78125 9.03375 5.852 9.08104 5.92987 9.11331C6.00774 9.14557 6.0912 9.16218 6.17549 9.16218C6.25978 9.16218 6.34325 9.14557 6.42112 9.11331C6.49899 9.08104 6.56974 9.03375 6.62933 8.97413L9.88783 5.71563C9.99728 5.60618 10.0588 5.45772 10.0588 5.30293C10.0588 5.14813 9.99728 4.99968 9.88783 4.89022C9.77837 4.78076 9.62991 4.71927 9.47512 4.71927C9.32032 4.71927 9.17187 4.78076 9.06241 4.89022Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_613_13821">
                            <rect width={14} height={14} fill="white" />
                          </clipPath>
                        </defs>
                      </svg>

                      <span className="text-white text-base">
                        Bera-friendly interface
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* footer */}
          <div className="grid grid-cols-[40px_1fr_112px] lg:grid-cols-[48px_1fr_112px] gap-2.5 lg:gap-4 p-4 bg-[#de8250]  border-t border-t-white/10">
            <div className="w-10 h-10 lg:w-12 lg:h-12 rounded-xl flex-shrink-0">
              <Image
                src={require("@/assets/icons/ic_bera_chain.png")}
                width={96}
                height={96}
                alt="DeFutures"
              />
            </div>

            <div className="flex flex-col justify-center">
              <p className="text-sm font-medium text-white line-clamp-1">
                Berachain
              </p>
              <p className="text-sm font-medium text-white/65 line-clamp-1">
                What we’re building
              </p>
            </div>
            <div className="flex items-center justify-center">
              {/* <div className="text-[#141416] text-center text-sm left-5 font-medium py-[10px] px-6 rounded-full bg-[#fff]">
                Explore
              </div> */}
            </div>
          </div>
        </div>
      </WrapperFinder>
    </Scale>
  );
}
